import axios from "axios";

const instance = axios.create({
  baseURL: "https://0sno1zqt7b.execute-api.ap-south-1.amazonaws.com/dev",
});

export default instance;
